// Served from `public/`, so a plain path works in dev, build, and tests.
const logo = "/logo.png";

const TRUST_BADGES = [
  {
    tone: "trust-blue",
    icon: "i",
    title: "Records In-Editor Only",
    copy: "Shows activity from this writing space.",
  },
  {
    tone: "trust-green",
    icon: "+",
    title: "Context-First Review",
    copy: "Supports instructor judgment with process notes.",
  },
  {
    tone: "trust-rose",
    icon: "!",
    title: "Not an Identity Check",
    copy: "Does not prove who wrote the work.",
  },
] as const;

export function Hero() {
  return (
    <header className="hero">
      <div className="hero-shell">
        <div className="hero-copy">
          <div className="brand-lockup" aria-label="ConText brand">
            <img className="brand-mark" src={logo} alt="ConText logo" />
            <div className="brand-copy">
              <h1>ConText</h1>
              <p className="brand-slogan">Text with context</p>
            </div>
          </div>
        </div>

        <details className="hero-details">
          <summary className="hero-summary">About ConText</summary>

          <aside className="hero-card">
            <h2>Purpose</h2>
            <p>
              ConText is a writing space where you can draft, revise, and submit your work in one
              place.
            </p>
            <p>
              While you write here, ConText records what happens in the editor so your instructor
              can review your final work with more context and you can better understand how your
              draft developed.
            </p>
            <ul className="hero-list">
              <li>Shows activity from this editor only</li>
              <li>Uses plain-language writing reminders</li>
              <li>Supports fair, context-aware review</li>
            </ul>
          </aside>

          <div className="hero-trust-row" aria-label="Security and privacy notice">
            {TRUST_BADGES.map((badge) => (
              <div className={`trust-badge ${badge.tone}`} key={badge.title}>
                <span className="trust-icon" aria-hidden="true">
                  {badge.icon}
                </span>
                <div>
                  <strong>{badge.title}</strong>
                  <p>{badge.copy}</p>
                </div>
              </div>
            ))}
          </div>
        </details>
      </div>
    </header>
  );
}
